import * as React from 'react';
import './articleTwoColTextAndQuote.scss';

import { Watch } from 'scrollmonitor-react';


class ArticleTwoColTextAndQuote extends React.Component {
  render() {
    let theBlock = this.props.block;
    let renderCite = false;
    let inView = this.props.isInViewport;
    let elementHasBeenInView = this.props.isAboveViewport;
 
    // Change classname based on boolean
    let viewClassName = (inView)? 'is-inview-true' : 'is-inview-false';
    let beenViewed = (elementHasBeenInView)? ' is-viewed' : ' is-not-viewed';

    if(this.props.block.blockQuoteAuthor !== "" | this.props.block.blockQuoteAuthorTitle !== "") {
        renderCite = true
    }
    function BlockQuote() {
        return (
            <>
            <div className="blockquote text-center">
                <hr className="quoteTop"/>
                <blockquote cite={theBlock.blockQuoteCite}>
                    <p>{theBlock.blockQuote}</p>
                </blockquote>
                {renderCite &&
                <cite>
                    {theBlock.blockQuoteAuthor !== "" ? <span className="author">{theBlock.blockQuoteAuthor}</span> : ""}
                    {theBlock.blockQuoteAuthorTitle !== "" ? <span className="authorTitle">{theBlock.blockQuoteAuthorTitle}</span> : ""}
                    {theBlock.blockQuoteAuthorTitleLineTwo !== "" ? <span className="authorTitle line-two">{theBlock.blockQuoteAuthorTitleLineTwo}</span> : ""}
                </cite>
                }
                <hr className="quoteBottom"/>
            </div>
            </>
        );
    }
    return (
    <div className={theBlock.blockHideOnMobile ? viewClassName + beenViewed + " d-none d-md-block " + theBlock.blockType : viewClassName + beenViewed + " " + theBlock.blockType}> 
        <div className="container"> 
            <div className="row">
                <div className="col-12 mb-sm-4">
                    <div className="row">
                        <div className="col-md-4 offset-md-2">
                            {theBlock.textFirst ? <div dangerouslySetInnerHTML={{__html: theBlock.blockHtml}} /> : <BlockQuote/>}
                        </div>
                        <div className="col-md-6">
                            {theBlock.textFirst ? <BlockQuote/> : <div dangerouslySetInnerHTML={{__html: theBlock.blockHtml}} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
  }
}

//const InviewOptions = {offsetY: 0.2, showGuides: false, fullElementInView: false, debounceTime: 30}

export default Watch(ArticleTwoColTextAndQuote);

